import { FC, ReactNode } from 'react'
import { Navbar } from './Navbar'
import { AccountSidebar } from './AccountSidebar'
import { useHasCompletedCreditApplication } from '../../hooks/useHasCompletedCreditApplication'

interface AccountLayoutProps {
  children: ReactNode
  // Fuerza el sidebar apagado sin importar el estatus de credit application
  // — para pantallas de onboarding (application-start, consulta de buró)
  // que reutilizan este shell solo por consistencia visual, pero donde el
  // menú de cuenta no aplica todavía. Si se omite, se decide con
  // useHasCompletedCreditApplication (Mis cotizaciones y las páginas de
  // cuenta reales).
  showSidebar?: boolean
}

// Shell de escritorio para las pantallas de cuenta (Mis cotizaciones, Mis
// arrendamientos, Mis documentos, Mi perfil, Configuración): franja
// superior + sidebar de navegación + contenido. Reutiliza el Navbar
// existente en vez de reconstruir el header.
export const AccountLayout: FC<AccountLayoutProps> = ({
  children,
  showSidebar,
}) => {
  const { hasCompletedApplication } = useHasCompletedCreditApplication()
  // Mientras el fetch está en curso, hasCompletedApplication empieza en
  // false, así que el sidebar simplemente no aparece hasta resolver — no
  // hace falta un estado de carga aparte.
  const shouldShowSidebar = showSidebar ?? hasCompletedApplication

  return (
    <div className="min-h-screen flex flex-col bg-olr-grey-1">
      <div className="sticky top-0 z-40">
        <Navbar />
      </div>
      <div className="flex flex-1 items-start gap-6 p-6">
        {shouldShowSidebar && <AccountSidebar />}
        <main className="flex-1 max-w-5xl mx-auto">{children}</main>
      </div>
    </div>
  )
}
